export default __webpack_public_path__ + "static/media/supercharge.4593f654.png";